import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CustomPipesModule } from '../../../pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputMaskModule } from '@ngneat/input-mask';
import { NewFieldEventsPage } from './new-field-events.page';
import { IonicModule } from '@ionic/angular';
import { ContactsModalCommonPageModule } from '../../ad-contacts/contacts-modal/common.module';
import { EventStaffModalCommonPageModule } from '../../event-staff/event-staff-modal/common.module';
@NgModule({
  imports: [CommonModule, CustomPipesModule, FormsModule, ReactiveFormsModule, InputMaskModule, IonicModule, ContactsModalCommonPageModule, EventStaffModalCommonPageModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [NewFieldEventsPage],
  exports: [NewFieldEventsPage],
})
export class NewFieldEventsPageModule {}